import { HTMLProps, forwardRef } from 'react';

import { Collapse } from '@material-ui/core';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

import { useSectionContext } from './SectionContext';

const styles = () =>
  createStyles({
    root: {},
  });

export interface SectionContentProps
  extends HTMLProps<HTMLDivElement>,
    WithStyles<typeof styles> {}

const SectionContentMui = forwardRef<HTMLDivElement, SectionContentProps>(
  (props, ref) => {
    const { className, classes, children, ...rest } = props;
    const { expanded } = useSectionContext();

    return (
      <Collapse in={expanded}>
        <div
          ref={ref}
          className={classNames(className, classes.root)}
          {...rest}
        >
          {children}
        </div>
      </Collapse>
    );
  },
);

SectionContentMui.displayName = 'SectionMui.Content';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore Section and delete. */
export default withStyles(styles)(SectionContentMui);
